import { makeAutoObservable } from 'mobx';
import moment from 'moment';
import {t} from 'shared/core';
import {auth, endpoints, types} from 'main/tools';
import {DomainStore} from 'shared/store';
import InterviewInvite from 'main/stores/recruiting/InterviewInvite';
import ScheduleInterviewState from 'main/containers/recruiting/state/ScheduleInterviewState';
import {successAlert, redirect} from 'shared/tools';

const CREATE_NEW_SCHEDULE = 'CREATE_NEW_SCHEDULE';

class InterviewInviteModalState {
  store = new DomainStore();

  scheduleInterviewState = new ScheduleInterviewState();
  interviewInvite = new InterviewInvite();
  errors = {};
  candidate;
  interviewSchedules = [];
  loadCandidate;
  onClose;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({candidate, interviewSchedules, loadCandidate, onClose, invite}) {
    this.candidate = candidate;
    this.interviewSchedules = interviewSchedules;
    this.loadCandidate = loadCandidate;
    this.onClose = onClose;
    this.interviewInvite = new InterviewInvite(invite);
    this.errors = {};
    this.interviewInvite.candidate = candidate;
  }

  get editing() {
    return !this.interviewInvite.isNew;
  }

  get scheduleOptions() {
    if (auth.hasAccess('::MANAGE_ATS')) {
      return [
        ...this.interviewSchedules,
        {id: CREATE_NEW_SCHEDULE, templateName: t('recruiting.hiring_funnel.+ Create New Interview Schedule')}
      ];
    }

    return this.interviewSchedules;
  }

  selectInterviewSchedule(schedule) {
    if (schedule.id === CREATE_NEW_SCHEDULE) {
      this.createNewInterviewSchedule();
      return;
    }

    this.interviewInvite.interviewSchedule = schedule;
    this.interviewInvite.startDate = schedule.resolvedStartDate;
    this.interviewInvite.endDate = schedule.resolvedEndDate;
  }

  async openPreviewModal() {
    this.scheduleInterviewState = new ScheduleInterviewState();
    await this.scheduleInterviewState.loadPreview({
      interviewScheduleId: this.interviewInvite.interviewSchedule.id,
      startDate: moment(this.interviewInvite.startDate).format('YYYY-MM-DD'),
      endDate: moment(this.interviewInvite.endDate).format('YYYY-MM-DD')
    });
  }

  async createNewInterviewSchedule() {
    const {model} = await this.store.post(
      endpoints.INTERVIEW_SCHEDULES.ALL,
      types.INTERVIEW_SCHEDULE
    );

    redirect(`/recruiting/interview-schedules/${model.id}/edit`);
  }

  async saveInterviewInvite() {
    const {model, errors} = this.editing ?
      await this.store.patch(this.interviewInvite) :
      await this.store.post(endpoints.INTERVIEW_INVITES, types.INTERVIEW_INVITE, this.interviewInvite);

    this.errors = errors;
    if (model) {
      successAlert(t(this.editing ? 'recruiting.alerts.Interview invite updated' : 'recruiting.alerts.Interview invite sent'));
      await this.loadCandidate();
      this.onClose();
    }
  }
}

export default InterviewInviteModalState;
